import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Apartments from './pages/Apartments';
import Plots from './pages/Plots';
import Commercial from './pages/Commercial';
import FarmLands from './pages/FarmLands';
import Villas from './pages/Villas';
import Loans from './pages/Loans';
import Contact from './pages/Contact';
import Admin from './pages/admin/Admin';

function App() {
  return (
    <BrowserRouter>
      <div className="app-layout">
        <Navbar />
        
        <main className="main-viewport">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Navigate to="/" />} />
            <Route path="/about" element={<About />} />
            <Route path="/apartments" element={<Apartments />} />
            <Route path="/plots" element={<Plots />} />
            <Route path="/commercial" element={<Commercial />} />
            <Route path="/villas" element={<Villas />} />
            <Route path="/farmlands" element={<FarmLands />} />
            <Route path="/loans" element={<Loans />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
